import React from 'react';

import type { EmbedNode } from './../../ricos-schema/next-schema';
import type { PluginProps } from './../../ricos-types';

import { embedConverter } from '../embed-converter';
import type { LinkPreviewPluginEditorConfig } from '../types';
import { EmbedViewer } from '../viewer/embed-viewer';

export const Embed: React.FC<PluginProps> = ({ settings, node }) => {
  const ricosNode = React.useMemo(() => embedConverter.fromPm.convert(node.toJSON()), [node]);

  return (
    <EmbedViewer
      node={ricosNode as EmbedNode}
      settings={settings as LinkPreviewPluginEditorConfig}
      iframeSandboxDomain={''}
    />
  );
};
